import { Component } from 'react';
import { NSARouterMakerResult } from "namirasoft-account-react";
import { SupportLayout } from "../SupportLayout";
import { SupportProps } from "../SupportProps";
import { SupportEntities } from "../SupportEntities";

export interface CategoryViewPageProps extends NSARouterMakerResult, SupportProps { }

class CategoryViewPage extends Component<CategoryViewPageProps>
{
    override render()
    {
        return (
            <SupportLayout
                {...this.props}
                pages={{
                    entity: SupportEntities.category(this.props),
                    ui: {
                        action: {
                            menus: {
                                view_history: false
                            }
                        }
                    },
                    view: {
                        ui: {
                            tab_page_view: {
                                tabs: {
                                    history: false
                                }
                            },

                        }
                    }
                }}
            >
                <></>
            </SupportLayout>
        );
    }
}

export default CategoryViewPage;